var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"emoji__item",attrs:{"title":_vm.emojiName},on:{"click":function($event){return _vm.$emit('click', {emoji: _vm.emoji, emojiName: _vm.emojiName})}}},[_vm._v("\n  "+_vm._s(_vm.emoji)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }